
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"#ffb93e","width":"16","height":"16","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('path',{attrs:{"d":"M8 16a8 8 0 10-8-8 8 8 0 008 8z"}}),_c('path',{attrs:{"fill":"none","stroke":"#fff","stroke-linecap":"round","stroke-linejoin":"round","d":"M9.14 3.43l2.29 2.28L9.14 8M4.57 5.71h6.86M6.86 12.57l-2.29-2.28L6.86 8M11.43 10.29H4.57"}})])
          )
        }
      }
    